import utils from '@eitje/utils'

export const formatMoney = value => {
	return utils.formatMoney(value)
}

export const MoneyCell = ({getValue}) => {
	return formatMoney(getValue())
}

export const MoneyCellWithoutZero = ({getValue}) => {
	const value = getValue()
	if (!value) return null
	return utils.formatMoney(value)
}
